import axios from 'axios';
import { SystemParameter } from '../types/systemParameter';

// Usar variável de ambiente para a base da URL
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`; 
const PARAMETERS_ENDPOINT = '/parameters'; // Mantém endpoint específico

class SystemParameterService {

  async getAllParameters(): Promise<SystemParameter[]> {
    try {
      const response = await axios.get<SystemParameter[]>(`${API_BASE_URL}${PARAMETERS_ENDPOINT}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar todos os parâmetros:', error);
      throw error;
    }
  }

  async getParameterByKey(key: string): Promise<SystemParameter | null> {
    try {
      const response = await axios.get<SystemParameter>(`${API_BASE_URL}${PARAMETERS_ENDPOINT}/${key}`);
      return response.data;
    } catch (error) {
       if (axios.isAxiosError(error) && error.response?.status === 404) {
         console.warn(`Parâmetro com chave ${key} não encontrado.`);
         return null;
       }
       console.error(`Erro ao buscar parâmetro ${key}:`, error);
       throw error;
    }
  }

  async updateParameter(key: string, value: string): Promise<SystemParameter> {
    try {
      const response = await axios.put<SystemParameter>(`${API_BASE_URL}${PARAMETERS_ENDPOINT}/${key}`, { value });
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar parâmetro ${key}:`, error);
      throw error;
    }
  }
}

export default new SystemParameterService(); 